import { makeECOptions, soulParse } from '../helpers/soulhelper'

self.onmessage = ev => {
  let funName = ev.data.method
  if (self[funName]) {
    self[funName](ev.data.params)
  } else {
    console.warn(`方法${funName}未定义`)
  }
}

self.makeECOptions = function (soul) {
  self.postMessage({
    type: 'makeECOptionsResponse',
    data: makeECOptions(soul)
  })
}
